import React from 'react';

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { MdmDeviceDto, useCreateDeviceMutation } from 'gql/generated/types';
import { useNavigate, useParams } from 'react-router-dom';
import DeviceForm from '../components/DeviceForm';

const NewDeviceForm = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [mutateFunction] = useCreateDeviceMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Device created successfully",
        life: 3000,
      });
      navigate(`/${projectId}/devices`);
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetAllDevicesByProject"],
  });

  const handleCreate = (device: MdmDeviceDto) => {
    const { objectRelation, project, ...restDevice } = device
    mutateFunction({
      variables: { device: { ...restDevice }, objectId: device.objectRelation?.mdmObject?.id! },
    });
  };
  
  return (
    <DeviceForm device={null} onSubmit={handleCreate} newForm/>
  )
}

export default NewDeviceForm